/* ET - language switch by URL.
   The header and footer language pickers are Shopify localization forms (POST /localization). The local
   `shopify theme dev` preview cannot proxy that POST (it answers 401 and shows a blank page), and on the
   storefront it costs an extra redirect. Language is part of the URL on this store (/en, /fr), so choosing
   one goes straight to the same page in that language: the hreflang alternate Shopify prints for it (it
   carries the translated handles), otherwise the current path under the language's root. Without JS the
   form still posts as before. */
(function () {
  if (window.__etLocaleLinks) return;
  window.__etLocaleLinks = true;

  var OPTION = 'button[name="locale_code"][data-et-locale-root]';

  function alternateFor(code) {
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    for (var i = 0; i < links.length; i++) {
      var lang = (links[i].getAttribute('hreflang') || '').toLowerCase();
      if (lang === code || lang.indexOf(code + '-') === 0) return links[i].href;
    }
    return null;
  }

  function targetFor(button) {
    var code = (button.value || '').toLowerCase();
    var alternate = alternateFor(code);
    if (alternate) {
      try {
        return new URL(alternate, window.location.href).pathname + window.location.search + window.location.hash;
      } catch (error) { /* fall through to the root swap */ }
    }
    var root = button.getAttribute('data-et-locale-root') || '/';
    var current = button.getAttribute('data-et-locale-current-root') || '/';
    var path = window.location.pathname;
    if (current !== '/' && (path === current || path.indexOf(current + '/') === 0)) {
      path = path.slice(current.length) || '/';
    }
    return (root === '/' ? '' : root.replace(/\/$/, '')) + path + window.location.search + window.location.hash;
  }

  function go(button, event) {
    event.preventDefault();
    event.stopPropagation();
    if (button.value === button.getAttribute('data-et-locale-current')) return;
    window.location.assign(targetFor(button));
  }

  /* Capture phase: Impact's <x-listbox> handles option clicks itself, so a bubbling listener never runs. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(OPTION);
    if (button) go(button, event);
  }, true);

  /* A submit that did not come from a click (keyboard selection, requestSubmit). */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector(OPTION)) return;
    var button = event.submitter && event.submitter.matches && event.submitter.matches(OPTION) ? event.submitter : null;
    if (button) go(button, event);
  }, true);
})();
